import http from '../../../services/api'
import type { APIPaginatedResponse, Filters, Pagination } from '../../../services/types'
import type { CommissionRuleApi, CommissionRuleWritePayload } from '../types'
import { getCommissionListParamString } from './commissionListQueryParams'

const apiPath = import.meta.env.VITE_API_PATH
const basePath = `${apiPath}commission/rules`

type CommissionRuleSingleResponse = { data: CommissionRuleApi }

async function getCommissionRules(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  const paramString = getCommissionListParamString(filters, pagination)
  return await http.get<APIPaginatedResponse<CommissionRuleApi>>(basePath + paramString)
}

async function getCommissionRule(uuid: string) {
  return await http.get<CommissionRuleSingleResponse>(`${basePath}/${uuid}`)
}

async function createCommissionRule(payload: CommissionRuleWritePayload) {
  return await http.post<CommissionRuleSingleResponse>(basePath, payload)
}

async function updateCommissionRule(uuid: string, payload: CommissionRuleWritePayload) {
  return await http.put<CommissionRuleSingleResponse>(`${basePath}/${uuid}`, payload)
}

async function deleteCommissionRule(uuid: string) {
  return await http.delete<undefined>(`${basePath}/${uuid}`)
}

const commissionRulesService = {
  getCommissionRules,
  getCommissionRule,
  createCommissionRule,
  updateCommissionRule,
  deleteCommissionRule,
}

export default commissionRulesService
